import React from 'react';
import CollapsibleCard from 'components/UI/CollapsibleCard';
import Component from './Loadable';

function Card()
{
    return (
        <CollapsibleCard
            titleType="primary"
            title="Recent Bookings"
            subtitle="Last 90 Days"
            subtitleMargin=""
            subtitlePadding=""
            titleMargin="tw-pb-2 tw-pt-2"
            customButtonBg="tw-bg-primary-default tw-text-black hover:tw-text-white"
            boxMargin="tw-mt-3"
            customBg="tw-bg-transparent"
            before={false}
            storeId="recent_bookings"
            defaultState
        >
            <Component />
        </CollapsibleCard>
    );
}

export default Card;
